import { render } from "./ctcp.vue?vue&type=template&id=ab415664&ts=true"
import script from "./ctcp.vue?vue&type=script&lang=ts"
export * from "./ctcp.vue?vue&type=script&lang=ts"

import exportComponent from "/home/webchat/thelounge-lfnet/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__